const createSourceObject = ({ order, payment, customer }) => {
  let sourceObject;
  console.log(payment);
  const { customer_invoice_address, customer_name, customer_email } = customer;

  const owner = {
    name: customer_name,
    email: customer_email,
    address: {
      city: customer_invoice_address.city,
      country: customer_invoice_address.country,
      line1: customer_invoice_address.street,
      postal_code: customer_invoice_address.zip,
    },
  };
  switch (payment.type) {
  case 'card':
    sourceObject = {
      type: payment.type,
      amount: order.order_amount,
      currency: order.order_currency,
      flow: payment.flow,
      owner,
    };
    break;
  case 'giropay':
    sourceObject = {
      type: payment.type,
      amount: order.order_amount,
      currency: order.order_currency,
      owner,
      redirect: {
        return_url: window.location.origin + '/order',
      },
      statement_descriptor: 'Ihre Bestellung bei der Opticunion GmbH',
      metadata: {
        order_id: order.order_id,
      },
    };
    break;
  case 'sepa_debit':
    sourceObject = {
      type: payment.type,
      amount: order.order_amount,
      currency: order.order_currency,
      owner,
      mandate: {
        notification_method: 'email',
      },
    };
    break;
  default:
    throw new Error('Unknown Payment method.');
  }

  return sourceObject;
};

module.exports = ({ actionType }) => () => next => action => {
  const REQUEST = actionType;
  if (action.type === REQUEST) {
    const { stripe, payment, order, customer } = action.payload;

    const sourceObject = createSourceObject({
      payment,
      order,
      customer,
    });

    return stripe.createSource(sourceObject).then(({ source, error }) => {
      if (error) {
        throw new Error(error.message);
      }
      return source;
    });
  }

  return next(action);
};



// WEBPACK FOOTER //
// ../shared/optilit-redux-middleware/stripe.js